// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uQ5uqbXHa8yMXO {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-left: var(--ds-space-150, 10px);
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
}
.a8d8bvykGdv83C {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-left: var(--ds-space-150, 10px);
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
}
.a8d8bvykGdv83C:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 0%, 0.08));
  text-decoration: none;
}
.body-dark-board-background .a8d8bvykGdv83C:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
html[data-color-mode='dark'] .a8d8bvykGdv83C:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
.a8d8bvykGdv83C:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 0%, 0.16));
}
.body-dark-board-background .a8d8bvykGdv83C:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
html[data-color-mode='dark'] .a8d8bvykGdv83C:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
.wN3GJhPuH3RkCt {
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.JEYAzfd7_hLv5B {
  flex: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  color: var(--dynamic-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.FSARh4pQOdFnGN {
  margin: var(--ds-space-0, 0) var(--ds-space-075, 6px);
  padding: var(--ds-space-050, 4px);
}
.dV4b2Fg5LmQdXy {
  padding: var(--ds-space-050, 4px);
}
.TAkuXfnA8bbU0V {
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  color: var(--ds-text, #172b4d);
}
.TAkuXfnA8bbU0V:hover {
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspaceLinkRow": `uQ5uqbXHa8yMXO`,
	"workspaceLink": `a8d8bvykGdv83C`,
	"joinButtonWrapper": `wN3GJhPuH3RkCt`,
	"workspaceLinkText": `JEYAzfd7_hLv5B`,
	"shortcutIcon": `FSARh4pQOdFnGN`,
	"shortcutIconFlagEnabled": `dV4b2Fg5LmQdXy`,
	"newWorkspacePage": `TAkuXfnA8bbU0V`
};
export default ___CSS_LOADER_EXPORT___;
